import mutations from '../mutations/mutationsHome.js'

export default {
    state: {
        isFullScreen: false
    },
    mutations: mutations()
}



// WEBPACK FOOTER //
// ./src/store/module/moduleHome.js